<div class="card h-100">
  <div class="card-header border-0 bg-transparent p-3">
    <div class="d-flex justify-content-between align-items-center">
      <h5 class="card-title mb-0">Vulnerability Events: Detected vs Mitigated</h5>
      <kendo-dropdownbutton
        kendoButton
        [svgIcon]="moreVerticalIcon"
        fillMode="flat"
        size="small"
        [data]="[{ text: 'View Data' }]"
        (itemClick)="onViewData()"
      ></kendo-dropdownbutton>
    </div>
    <div class="metric-subtext bg-dark bg-opacity-25 text-primary p-2 rounded mt-2">
      Patched in selected period: {{ vulnerabilityEventsResponse().patchingStats.patchedPercentage }}%
    </div>
  </div>
  <div class="card-body">
    <kendo-chart>
      <kendo-chart-series>
        <kendo-chart-series-item
          type="line"
          [style]="'smooth'"
          [data]="chartData()"
          field="detected"
          categoryField="date"
          name="Detected"
          [color]="'#ef5350'"
          [markers]="{ visible: true, size: 6 }">
          <kendo-chart-tooltip format="{0}"></kendo-chart-tooltip>
        </kendo-chart-series-item>
        <kendo-chart-series-item
          type="area"
          [style]="'smooth'"
          [data]="chartData()"
          field="mitigated"
          categoryField="date"
          name="Mitigated"
          [color]="'#66bb6a'"
          [markers]="{ visible: true, size: 6 }"
          [opacity]="0.3">
          <kendo-chart-tooltip format="{0}"></kendo-chart-tooltip>
        </kendo-chart-series-item>
      </kendo-chart-series>
      <kendo-chart-category-axis>
        <kendo-chart-category-axis-item>
          <kendo-chart-category-axis-item-labels format="{0:MMM d}"></kendo-chart-category-axis-item-labels>
        </kendo-chart-category-axis-item>
      </kendo-chart-category-axis>
      <kendo-chart-value-axis>
        <kendo-chart-value-axis-item>
          <kendo-chart-value-axis-item-labels format="{0}"></kendo-chart-value-axis-item-labels>
        </kendo-chart-value-axis-item>
      </kendo-chart-value-axis>
      <kendo-chart-legend position="bottom"></kendo-chart-legend>
    </kendo-chart>
  </div>
</div>

@if (showPopup()) {
  <kendo-dialog
    (close)="close()"
    [width]="'95vw'"
    [height]="'90vh'"
    [minWidth]="'800px'"
    [maxWidth]="'1400px'"
  >
    <kendo-dialog-titlebar>{{ modalTitle() }}</kendo-dialog-titlebar>

    @if (datatableUrl(); as url) {
      <div class="table-responsive w-100">
        <app-datatable
          [data-href]="url"
          [columns]="datatableColumns"
          [useOData]="true"
          [initialFilters]="periodParams()"
        ></app-datatable>
      </div>
    }
  </kendo-dialog>
}
